export { postInstallationOrderResolve, postRemovalOrderResolve, postSalesOrderResolve } from "./api/orderResolveApi";
export { buildInstallationResolvePayload } from "./builders/buildInstallationResolvePayload";
export type { BuildInstallationResolveInput } from "./builders/buildInstallationResolvePayload";
export { buildInstallationEditResolveLineItems } from "./builders/buildInstallationEditResolveLineItems";
export type { InstallationEditResolveProduct } from "./builders/buildInstallationEditResolveLineItems";
export { buildInstallationAddResolveLineItems } from "./builders/buildInstallationAddResolveLineItems";
export type {
  InstallationAddResolveCatalogProduct,
  InstallationAddResolveCustomProduct,
  BuildInstallationAddResolveLineItemsInput,
} from "./builders/buildInstallationAddResolveLineItems";
export { applyInstallationResolveResponse } from "./mappers/applyInstallationResolveResponse";
export type {
  ApplyInstallationResolveOptions,
  ApplyInstallationResolveResult,
} from "./mappers/applyInstallationResolveResponse";
export {
  installationFeeRequired,
  installationFeeTaxable,
  mapInstallationSpecialFeeForResolve,
  mapInstallationSpecialFeeForSubmit,
  mapSavedInstallationSpecialFeeToUi,
  normalizeInstallationSelectedFee,
} from "./utils/mapInstallationSpecialFee";
export type { InstallationUiSpecialFee } from "./utils/mapInstallationSpecialFee";
export {
  getResolvedDiscountDisplay,
  getOrderDiscountFieldDisplay,
  getInstallationCostBreakdownDiscount,
} from "./mappers/getResolvedDiscountDisplay";
export type { InstallationOrderDiscountSource } from "./mappers/getResolvedDiscountDisplay";
export { buildRemovalResolvePayload } from "./builders/buildRemovalResolvePayload";
export type { BuildRemovalResolveInput } from "./builders/buildRemovalResolvePayload";
export { applyRemovalResolveResponse } from "./mappers/applyRemovalResolveResponse";
export type {
  ApplyRemovalResolveOptions,
  ApplyRemovalResolveResult,
} from "./mappers/applyRemovalResolveResponse";
export { overlayRemovalSubmitFromResolved } from "./mappers/overlayRemovalSubmitFromResolved";
export { applyRemovalWorkOrderResolveResponse } from "./mappers/applyRemovalWorkOrderResolveResponse";
export type {
  ApplyRemovalWorkOrderResolveOptions,
  ApplyRemovalWorkOrderResolveResult,
} from "./mappers/applyRemovalWorkOrderResolveResponse";
export {
  buildRemovalPatchFromResolved,
  removalOverallTaxFromResolved,
} from "./mappers/buildRemovalPatchFromResolved";
export { overlayInstallationSubmitFromResolved } from "./mappers/overlayInstallationSubmitFromResolved";
export { applyInstallationEditResolveResponse } from "./mappers/applyInstallationEditResolveResponse";
export type { ApplyInstallationEditResolveOptions } from "./mappers/applyInstallationEditResolveResponse";
export {
  buildInstallationPatchFromResolved,
  mergeResolvedTaxIntoLineItems,
} from "./mappers/buildInstallationPatchFromResolved";
export { mapInstallationOrderLinesToResolved } from "./mappers/mapInstallationOrderLinesToResolved";
export {
  inferInstallationDiscountScope,
  inferInstallationDiscountScopeFromResolved,
  inferInstallationDiscountScopeForResolveRequest,
  splitInstallationDiscountForPayload,
  getInstallationResolveRootDiscountCode,
  purchasedResolveLineItemCount,
} from "./mappers/installationDiscountScope";
export type { InstallationDiscountScope } from "./mappers/installationDiscountScope";
export type {
  InstallationResolvePayload,
  InstallationResolveRequest,
  ResolvedInstallationOrder,
  ResolvedInstallationLineItem,
  InstallationResolveAddress,
  OrderResolveAction,
} from "./types/installation";
export type {
  RemovalResolvePayload,
  RemovalResolveRequest,
  ResolvedRemovalOrder,
} from "./types/removal";
export { buildSalesResolvePayload } from "./builders/buildSalesResolvePayload";
export type { BuildSalesResolveInput } from "./builders/buildSalesResolvePayload";
export { pickSalesResolveBuyerContext } from "./builders/pickSalesResolveBuyerContext";
export type {
  PickSalesResolveBuyerInput,
  SalesResolveBuyerContext,
} from "./builders/pickSalesResolveBuyerContext";
export { buildSalesResolveOrderItems } from "./builders/buildSalesResolveOrderItems";
export type {
  BuildSalesResolveCatalogRow,
  BuildSalesResolveCustomRow,
  BuildSalesResolveOrderItemsInput,
} from "./builders/buildSalesResolveOrderItems";
export { applySalesResolveResponse, mergeSelectedProductsFromResolved, remapSalesResolveLineMaps } from "./mappers/applySalesResolveResponse";
export type { SalesResolveUiSync, ApplySalesResolveResponseOptions, SalesResolveSourceRow } from "./mappers/applySalesResolveResponse";
export { overlaySalesSubmitFromResolved } from "./mappers/overlaySalesSubmitFromResolved";
export {
  coalesceOrderChargeRows,
  getCheckoutOrderChargeFallbacks,
  readOrderChargesBlock,
} from "./utils/coalesceOrderChargeRows";
export {
  getSalesResolvedDiscountDisplay,
  getSalesOrderDiscountFieldDisplay,
} from "./mappers/getSalesResolvedDiscountDisplay";
export { buildSalesResolvePayloadFromSavedOrder } from "./builders/buildSalesResolvePayloadFromSavedOrder";
export type { BuildSalesResolveFromSavedOrderOptions } from "./builders/buildSalesResolvePayloadFromSavedOrder";
export { syncSalesViewStateFromResolved } from "./mappers/syncSalesViewStateFromResolved";
export {
  mapCheckoutCartToResolveCatalogRows,
  mergeCheckoutCartFromResolved,
  perItemCouponMapFromResolved,
  pickAgentCheckoutResolveBuyer,
  pickRealtorCheckoutResolveBuyer,
  buildCheckoutOrderPartyFields,
  readCheckoutCartLineTaxable,
  getCheckoutLineItemId,
  normalizeSalesLineItemMongoId,
} from "./checkout/checkoutSalesResolveHelpers";
export type { CheckoutCartLine } from "./checkout/checkoutSalesResolveHelpers";
export {
  finalizeSalesOrderTaxAfterPaid,
  fetchSalesOrderForPaidFinalize,
} from "./checkout/finalizeSalesOrderTaxAfterPaid";
export {
  patchInstallationOrderTaxComplete,
  patchRemovalOrderTaxComplete,
} from "./checkout/patchJobOrderTaxAfterResolveComplete";
export type {
  SalesResolvePayload,
  SalesResolveRequest,
  ResolvedSalesOrder,
  ResolvedSalesOrderItem,
} from "./types/sales";
